<template>
  <div class="app">
    <div class="logo">
      <svg height="24" viewBox="0 0 171 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M33.377 17.819c-1.578-1.495-2.346-3.394-2.346-5.656 0-2.222.768-4.12 2.346-5.615 1.576-1.495 3.558-2.262 5.862-2.262 2.103 0 3.923.646 5.419 1.898 1.536 1.253 2.426 2.869 2.75 4.767h-2.831c-.283-1.212-.89-2.222-1.86-2.99-.97-.767-2.143-1.13-3.477-1.13-1.537 0-2.83.525-3.882 1.535-1.051 1.01-1.577 2.302-1.577 3.797s.526 2.787 1.577 3.797c1.051 1.01 2.345 1.535 3.882 1.535a5.559 5.559 0 003.477-1.171c.97-.768 1.617-1.737 1.86-2.949h2.83c-.283 1.94-1.213 3.515-2.75 4.767-1.536 1.252-3.315 1.899-5.417 1.899-2.305.04-4.287-.687-5.864-2.222zM49.914 19.839V4.569h2.71v15.27h-2.71zM66.088 4.569v2.464h-4.245v12.806h-2.67V7.033h-4.245V4.569h11.16zM77.572 19.839l-1.254-3.232h-7.116l-1.294 3.232h-2.911l6.186-15.27h3.194l6.187 15.27h-2.992zm-7.44-5.696h5.216L72.72 7.437l-2.588 6.706zM88.691 4.569c2.305 0 4.165.727 5.701 2.181 1.537 1.454 2.265 3.272 2.265 5.454 0 2.181-.768 3.999-2.264 5.453-1.537 1.454-3.438 2.182-5.702 2.182h-6.065V4.569h6.065zm-.04 12.765c1.496 0 2.75-.485 3.76-1.495 1.011-.97 1.496-2.222 1.496-3.676 0-1.454-.485-2.706-1.496-3.676-1.01-.97-2.264-1.454-3.76-1.454h-3.356v10.301h3.356zM101.954 17.334h6.267v2.464h-8.976V4.568h8.855v2.465h-6.146v3.878h5.378v2.464h-5.378v3.959zM113.518 17.334h5.58v2.464h-8.248V4.568h2.709v12.766h-.041zM122.737 20c-.526 0-.97-.162-1.294-.485a1.704 1.704 0 01-.526-1.252c0-.485.162-.93.526-1.252.364-.323.768-.525 1.294-.525s.97.161 1.294.525c.364.323.526.767.526 1.252 0 .525-.162.93-.526 1.252-.324.323-.768.485-1.294.485zM133.938 20.08c-2.346 0-4.327-.767-5.904-2.261-1.577-1.495-2.345-3.394-2.345-5.656 0-2.222.768-4.12 2.345-5.615 1.577-1.495 3.558-2.262 5.904-2.262 2.345 0 4.326.767 5.863 2.262 1.577 1.495 2.345 3.393 2.345 5.615 0 2.262-.768 4.12-2.345 5.656-1.537 1.535-3.518 2.262-5.863 2.262zM137.86 16c1.051-1.01 1.577-2.302 1.577-3.796 0-1.495-.526-2.788-1.577-3.798-1.051-1.01-2.345-1.535-3.922-1.535-1.537 0-2.831.525-3.882 1.535-1.051 1.01-1.577 2.303-1.577 3.797 0 1.495.526 2.788 1.577 3.798 1.051 1.01 2.345 1.535 3.882 1.535 1.577 0 2.871-.525 3.922-1.535zM155.368 4.569h2.709v15.27h-2.75l-7.844-10.786v10.786h-2.709V4.569h2.749l7.845 10.785V4.57zM164.183 17.334h6.267v2.464h-8.976V4.568h8.814v2.465h-6.146v3.878h5.378v2.464h-5.378v3.959h.041zM12.327 1.303c4.663 0 8.614 3 10.076 7.144.158.514.592.908 1.145.908.554 0 1.107-.237 1.107-.908V1.618c0-.907-.751-1.618-1.62-1.618H1.62C.75 0 0 .75 0 1.618v20.724c0 .908.75 1.619 1.62 1.619h21.375c.909 0 1.62-.75 1.62-1.619v-6.829c0-.631-.434-1.105-1.067-1.105-.632 0-1.027.474-1.224 1.105a10.504 10.504 0 01-9.997 7.184A10.686 10.686 0 011.62 12c0-5.921 4.78-10.697 10.707-10.697z"></path>
      </svg>
    </div>
    
    <button v-if="foundKeys" class="erase-btn" type="button" @click="showEraseModal = true">
      ERASE DATA
    </button>

    <div class="container">
      <div v-if="!foundKeys" class="card">
        <h2 class="title">
          <!-- <svg class="title-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 8v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" stroke="#ff4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg> -->
          {{ !foundKeys ? 'Backup unavailable' : !decodedMnemonic ? 'Backup available' : 'Wallets ready for backup' }}
        </h2>
        <!-- <p class="warning">The Citadel.one will be permanently sunset on February 27, 2026.<br>Please back up your seed phrase NOW so you can continue using them in other apps.</p> -->
        <p class="message">No backup found for <strong style="color: #6a4bff;">app.citadel.one</strong> wallet</p>
      </div>

      <div v-else-if="!decodedMnemonic" class="card">
        <h2 class="title">
          <!-- <svg class="title-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 8v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" stroke="#ff4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg> -->
          {{ !decodedMnemonic ? 'Backup available' : 'Wallets ready for backup' }}
        </h2>
        <p v-if="!decodedMnemonic" class="warning">Please enter your Citadel.one password to access backup via the seed phase.</p>
        <p v-else class="warning">The Citadel.one will be permanently sunset on February 27, 2026.<br>Please back up your seed phrase NOW so you can continue using them in other apps.</p>
        
        <div class="wallets-banner">
          <div class="wallets-banner__title">Found wallets</div>
          <div class="wallets-banner__row">
            <span class="wallets-banner__label">Main seed phrase:</span>
            <span class="wallets-banner__value">{{ oneSeedWalletsCount }} wallets</span>
          </div>
          <div v-if="importedSeedWalletsCount > 0" class="wallets-banner__row">
            <span class="wallets-banner__label">Custom seed phrase:</span>
            <span class="wallets-banner__value">{{ importedSeedWalletsCount }} wallets</span>
          </div>
        </div>

        <div class="input-wrapper">
          <input
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            placeholder="Enter your password"
            class="password-input"
            @keyup.enter="handleDecode"
            :disabled="loading"
          />
          <div class="input-actions">
            <button
              v-if="password"
              @click="togglePasswordVisibility"
              class="action-btn"
              type="button"
            >
              <svg v-if="showPassword" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.173 8C2.224 5.23 4.81 3.5 8 3.5c3.19 0 5.776 1.73 6.827 4.5-.527 1.387-1.34 2.558-2.327 3.38M11.333 11.333A5.333 5.333 0 0 1 4.667 4.667M14.14 1.86l-12.28 12.28M1.173 8C2.224 10.77 4.81 12.5 8 12.5c1.74 0 3.307-.64 4.5-1.667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.173 8C2.224 5.23 4.81 3.5 8 3.5c3.19 0 5.776 1.73 6.827 4.5C14.3 9.387 13.487 10.558 12.5 11.38M8 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button
              v-if="password"
              @click="clearPassword"
              class="action-btn"
              type="button"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </div>

        <button
          @click="handleDecode"
          class="submit-btn"
          :disabled="loading"
        >
          {{ loading ? 'Decoding...' : 'Continue' }}
        </button>

        <p v-if="error" class="error">{{ error }}</p>
      </div>

      <div v-else class="card">
        <h2 class="title">
          <!-- <svg class="title-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 8v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" stroke="#4caf50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg> -->
          {{ !decodedMnemonic ? 'Backup available' : 'Wallets ready for backup' }}
        </h2>
        <p class="warning">Please backup your wallets NOW. Write them down or save it securely using other methods.</p>
        
        <h3 class="seed-title">Main seed phrase</h3>
        <div class="mnemonic-display">
          <div class="mnemonic-text mnemonic-text--main">
            <div class="mnemonic-seed">{{ decodedMnemonic }}</div>
            <div v-if="oneSeedWalletsCount > 0" class="wallet-info-row">
              <div class="wallet-info-cell">
                <div class="wallet-info-label">Wallets</div>
                <div class="wallet-info-value">{{ oneSeedWalletsCount }}</div>
              </div>
              <div class="wallet-info-cell wallet-info-cell--button">
                <button class="wallets-btn" type="button" @click="showWalletsModal = true">
                  Show wallets
                </button>
              </div>
            </div>
          </div>
          <button @click="copyToClipboard" class="copy-btn-small">
            <svg v-if="!copied" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="6" y="6" width="8" height="8" rx="1" stroke="currentColor" stroke-width="1.5" fill="none"/>
              <rect x="2" y="2" width="8" height="8" rx="1" stroke="currentColor" stroke-width="1.5" fill="none"/>
            </svg>
            <span v-else class="copied-text">✓</span>
          </button>
        </div>

        <div v-if="customWallets.length" :class="['custom-wallets', { 'custom-wallets-scrollable': customWallets.length > 1 }]">
          <h3 class="seed-title" style="margin-bottom: 5px;">Imported seed phrases</h3>
          <div v-for="(wallet, index) in customWallets" :key="index" class="custom-wallet-item">
            <div class="mnemonic-display-compact">
              <div class="mnemonic-text mnemonic-text--wallet">
                <div class="mnemonic-seed">{{ wallet.decodedSeed }}</div>
                <div class="wallet-info-row">
                  <div class="wallet-info-cell">
                    <div class="wallet-info-label">Name</div>
                    <div class="wallet-info-value wallet-name">{{ wallet.name }}</div>
                  </div>
                  <div class="wallet-info-cell">
                    <div class="wallet-info-label">Address</div>
                    <div class="wallet-info-value wallet-address">{{ wallet.address }}</div>
                  </div>
                  <div class="wallet-info-cell">
                    <div class="wallet-info-label">Derivation</div>
                    <div class="wallet-info-value wallet-path">{{ wallet.derivationPath }}</div>
                  </div>
                </div>
              </div>
              <button @click="copyCustomSeed(wallet.decodedSeed, index)" class="copy-btn-small">
                <svg v-if="!wallet.copied" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="6" y="6" width="8" height="8" rx="1" stroke="currentColor" stroke-width="1.5" fill="none"/>
                  <rect x="2" y="2" width="8" height="8" rx="1" stroke="currentColor" stroke-width="1.5" fill="none"/>
                </svg>
                <span v-else class="copied-text">✓</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div v-if="showWalletsModal" class="wallets-modal-backdrop" @click.self="closeWalletsModal">
      <div class="wallets-modal">
        <div class="wallets-modal__header">
          <h3 class="wallets-modal__title">Wallets from this seed</h3>
          <button class="wallets-modal__close" type="button" @click="closeWalletsModal">
            ×
          </button>
        </div>
        <div class="wallets-modal__body">
          <div
            v-for="(wallet, index) in oneSeedWalletsList"
            :key="index"
            class="wallets-modal__row"
          >
            <div class="wallets-modal__name">{{ wallet.name || 'N/A' }}</div>
            <div class="wallets-modal__field">
              <span class="wallets-modal__label">Address</span>
              <span class="wallets-modal__value">{{ wallet.address || 'N/A' }}</span>
            </div>
            <div class="wallets-modal__field">
              <span class="wallets-modal__label">Derivation</span>
              <span class="wallets-modal__value">{{ wallet.derivationPath || 'N/A' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div v-if="showEraseModal" class="wallets-modal-backdrop" @click.self="closeEraseModal">
      <div class="wallets-modal">
        <div class="wallets-modal__header">
          <div class="wallets-modal__title-wrap">
            <svg class="erase-modal__icon" width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 8v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" stroke="#ff4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <h3 class="wallets-modal__title">Erase data</h3>
          </div>
          <button class="wallets-modal__close" type="button" @click="closeEraseModal">
            ×
          </button>
        </div>
        <div class="wallets-modal__body">
          <div class="erase-modal__text">Your data will be permanently deleted.</div>
          <div class="erase-modal__actions">
            <button class="erase-modal__agree" type="button" @click="eraseData">
              I Agree
            </button>
            <button class="erase-modal__cancel" type="button" @click="closeEraseModal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
import { sha3_256 } from 'js-sha3';

export default {
  name: 'App',
  data() {
    return {
      password: '',
      decodedMnemonic: null,
      foundKeys: false,
      loading: false,
      error: '',
      copied: false,
      userData: null,
      showPassword: false,
      customWallets: [],
      walletsData: null,
      showWalletsModal: false,
      showEraseModal: false
    }
  },
  computed: {
    isPasswordInvalid() {
      if (!this.password || !this.userData) {
        return true
      }
      const passwordHash = this.hashPassword(this.password)
      return passwordHash !== this.userData.passwordHash
    },
    oneSeedWalletsCount() {
      if (!this.walletsData || !Array.isArray(this.walletsData)) {
        return 0
      }
      return this.walletsData.filter(wallet => wallet.type === 'oneSeed').length
    },
    importedSeedWalletsCount() {
      if (!this.walletsData || !Array.isArray(this.walletsData)) {
        return 0
      }
      return this.walletsData.filter(wallet => !!wallet.importedFromSeed).length
    },
    oneSeedWalletsList() {
      if (!this.walletsData || !Array.isArray(this.walletsData)) {
        return []
      }
      return this.walletsData.filter(wallet => wallet.type === 'oneSeed')
    }
  },
  mounted() {
    this.findUserKeys()
  },
  methods: {
    findUserKeys() {
      // Scan localStorage for user_{num} keys
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (key && key.startsWith('user_')) {
          try {
            const value = localStorage.getItem(key)
            const parsed = JSON.parse(value)
            
            if (parsed.crypto && parsed.crypto.passwordHash && parsed.crypto.mnemonic) {
              this.userData = parsed.crypto
              this.foundKeys = true;
              
              // Check for custom wallets
              if (parsed.wallets && parsed.wallets.wallets && Array.isArray(parsed.wallets.wallets)) {
                this.walletsData = parsed.wallets.wallets
              }
              
              return
            }
          } catch (e) {
            // Skip invalid JSON
            continue
          }
        }
      }
      this.foundKeys = false
    },
    
    hashPassword(password) {
      return sha3_256(password);
    },
    
    decodeMnemonic(encodeMnemonic, password) {
      return CryptoJS.AES
        .decrypt(encodeMnemonic, password)
        .toString(CryptoJS.enc.Utf8)
    },
    
    handleDecode() {
      if (!this.password) return
      
      this.loading = true
      this.error = ''
      
      try {
        // Hash the entered password and compare with stored passwordHash
        const passwordHash = this.hashPassword(this.password)
        
        if (passwordHash !== this.userData.passwordHash) {
          this.error = 'Incorrect password. Please try again.'
          this.loading = false
          return
        }
        
        // Password is correct, decode the mnemonic
        const decoded = this.decodeMnemonic(this.userData.mnemonic, this.password)
        
        if (!decoded || decoded.trim() === '') {
          this.error = 'Failed to decode mnemonic. Please check your password.'
          this.loading = false
          return
        }
        
        this.decodedMnemonic = decoded
        
        // Decode custom wallets if they exist
        if (this.walletsData && Array.isArray(this.walletsData)) {
          this.customWallets = []
          this.walletsData.forEach(wallet => {
            if (wallet.importedFromSeed) {
              try {
                const decodedSeed = this.decodeMnemonic(wallet.importedFromSeed, this.password)
                if (decodedSeed && decodedSeed.trim() !== '') {
                  this.customWallets.push({
                    name: wallet.name || 'N/A',
                    address: wallet.address || 'N/A',
                    derivationPath: wallet.derivationPath || 'N/A',
                    decodedSeed: decodedSeed,
                    copied: false
                  })
                }
              } catch (e) {
                console.error('Failed to decode custom wallet seed:', e)
              }
            }
          })
        }
      } catch (error) {
        this.error = 'An error occurred while decoding. Please try again.'
        console.error('Decode error:', error)
      } finally {
        this.loading = false
      }
    },
    
    clearPassword() {
      this.password = ''
      this.error = ''
      this.showPassword = false
    },
    
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    
    copyToClipboard() {
      navigator.clipboard.writeText(this.decodedMnemonic).then(() => {
        this.copied = true
        setTimeout(() => {
          this.copied = false
        }, 2000)
      })
    },
    
    copyCustomSeed(seed, index) {
      navigator.clipboard.writeText(seed).then(() => {
        this.customWallets[index].copied = true
        setTimeout(() => {
          this.customWallets[index].copied = false
        }, 2000)
      })
    },
    
    closeWalletsModal() {
      this.showWalletsModal = false
    },
    
    closeEraseModal() {
      this.showEraseModal = false
    },
    
    eraseData() {
      try {
        localStorage.clear()
      } catch (e) {
        console.error('Failed to clear localStorage:', e)
      }
      this.showEraseModal = false
      // Reset app state
      this.password = ''
      this.decodedMnemonic = null
      this.foundKeys = false
      this.error = ''
      this.copied = false
      this.userData = null
      this.customWallets = []
      this.walletsData = null
      this.findUserKeys()
    }
  }
}
</script>

<style lang="scss">
// Panton font faces - uncomment and add font files to src/assets/fonts/ when available
// @font-face {
//   font-family: 'Panton';
//   src: url('../assets/fonts/Panton-Regular.woff2') format('woff2'),
//        url('../assets/fonts/Panton-Regular.woff') format('woff');
//   font-weight: 400;
//   font-style: normal;
//   font-display: swap;
// }

// @font-face {
//   font-family: 'Panton';
//   src: url('../assets/fonts/Panton-Medium.woff2') format('woff2'),
//        url('../assets/fonts/Panton-Medium.woff') format('woff');
//   font-weight: 500;
//   font-style: normal;
//   font-display: swap;
// }

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  font-family: 'Panton', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  overflow: hidden;
}

.app {
  height: 100vh;
  background: rgb(239, 243, 252);
  padding: 24px;
  position: relative;
}

.logo {
  position: absolute;
  top: 24px;
  left: 24px;
  z-index: 10;
  
  svg {
    path {
      fill: #000;
    }
  }
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding-top: 60px;
  margin-top: -50px;
}

.card {
  background: #fff;
  box-shadow: -10px 4px 27px rgba(0, 0, 0, 0.1);
  border-radius: 25px;
  border-top: 10px solid #6a4bff;
  padding: 40px;
  max-width: 700px;
  width: 100%;
  max-height: 650px;
  overflow-y: auto;
  overflow-x: hidden;
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
    margin: 10px 0;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #e2e2e2;
    border-radius: 4px;
    
    &:hover {
      background:#e2e2e2;
    }
  }
}

.title {
  font-family: 'Panton', sans-serif;
  font-weight: 500;
  font-size: 28px;
  color: #1a1a1a;
  margin-bottom: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.title-icon {
  flex-shrink: 0;
}

.warning {
  font-family: 'Panton', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #666;
  text-align: center;
  line-height: 1.6;
  margin-bottom: 30px;
}

.message {
  font-family: 'Panton', sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: #666;
  text-align: center;
  line-height: 1.6;
}

.wallets-banner {
  background: #f0f2f7;
  border: 1px solid #dde2ee;
  border-radius: 12px;
  padding: 10px 12px;
  margin: 8px 0 14px;
}

.wallets-banner__title {
  font-family: 'Panton', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 6px;
}

.wallets-banner__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  font-family: 'Panton', sans-serif;
  font-size: 12px;
  line-height: 1.2;
  margin-bottom: 4px;
}

.wallets-banner__row:last-child {
  margin-bottom: 0;
}

.wallets-banner__label {
  font-weight: 600;
  color: #4b5f80;
  // text-transform: lowercase;
}

.wallets-banner__value {
  font-weight: 700;
  color: #1a1a1a;
  white-space: nowrap;
}

.input-wrapper {
  position: relative;
  margin-bottom: 20px;
}

.password-input {
  width: 100%;
  padding: 16px 90px 16px 20px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-family: 'Panton', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #1a1a1a;
  background: #fff;
  transition: all 0.3s ease;
  
  &:focus {
    outline: none;
    border-color: rgb(239, 243, 252);
    box-shadow: 0 0 0 3px rgba(239, 243, 252, 0.1);
  }
  
  &:disabled {
    background: #f5f5f5;
    cursor: not-allowed;
  }
  
  &::placeholder {
    color: #999;
  }
}

.input-actions {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  transition: color 0.2s ease;
  
  &:hover {
    color: #666;
  }
  
  svg {
    display: block;
  }
}

.submit-btn {
  width: 100%;
  padding: 16px;
  background: #6a4bff;
  border: none;
  border-radius: 8px;
  font-family: 'Panton', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover:not(:disabled) {
    background: #5a3bef;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(106, 75, 255, 0.3);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.error {
  margin-top: 16px;
  padding: 12px;
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 8px;
  color: #c33;
  font-family: 'Panton', sans-serif;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
}

.mnemonic-display {
  margin-top: 5px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.mnemonic-text {
  flex: 1;
  background: #f8f9fa;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  font-family: 'Panton', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #1a1a1a;
  line-height: 1.8;
  word-break: break-all;
  min-height: 100px;
}

.copy-btn {
  width: 100%;
  padding: 16px;
  background: #6a4bff;
  border: none;
  border-radius: 8px;
  font-family: 'Panton', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: #5a3bef;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(106, 75, 255, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
}

.seed-title {
  font-family: 'Panton_Medium', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #59779a;
  margin-top: 30px;
  margin-bottom: 0;
  
  &:first-of-type {
    margin-top: 0;
  }
}

.custom-wallets {
  margin-top: 30px;
}

.custom-wallets-scrollable {
  max-height: 400px;
  overflow-y: scroll !important;
  overflow-x: hidden;
  padding-right: 8px;
  position: relative;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #6a4bff;
    border-radius: 3px;
    
    &:hover {
      background: #5a3bef;
    }
  }
}

.custom-wallet-item {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
  
  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
}

.wallet-info-compact {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-family: 'Panton', sans-serif;
  font-size: 12px;
  color: #666;
  flex-wrap: wrap;
}

.wallet-name {
  font-weight: 600;
  color: #000;
  word-break: break-all;
}

.wallet-address {
  font-weight: 400;
  color: #274fe1;
  word-break: break-all;
}

.wallet-separator {
  color: #999;
}

.wallet-path {
  font-weight: 400;
  color: #274fe1;
  word-break: break-all;
}

.mnemonic-display-compact {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.mnemonic-text--wallet,
.mnemonic-text--main {
  padding: 12px;
  min-height: auto;
}

.mnemonic-seed {
  margin-bottom: 10px;
}

.wallet-info-row {
  display: grid;
  grid-template-columns: 1.1fr 1.4fr 1.1fr;
  gap: 6px;
  margin-top: 6px;
}

.mnemonic-text--main .wallet-info-row {
  grid-template-columns: 1fr 1fr;
}

.wallet-info-cell {
  background: #f0f2f7;
  border: 1px solid #dde2ee;
  border-radius: 6px;
  padding: 6px 8px;
  min-width: 0;
}

.wallet-info-label {
  font-family: 'Panton', sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #4b5f80;
  line-height: 1.2;
  margin-bottom: 4px;
}

.wallet-info-value {
  font-family: 'Panton', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.2;
  word-break: break-all;
}

.wallet-info-cell--button {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.wallets-btn {
  width: 100%;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #dde2ee;
  background: #f0f2f7;
  color: #1a1a1a;
  font-family: 'Panton', sans-serif;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  
  &:hover {
    background: #e8ebf0;
  }
  
  &:active {
    background: #e0e4ea;
  }
}

.wallets-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.wallets-modal {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.25);
  width: 520px;
  max-width: calc(100% - 32px);
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.wallets-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 8px;
}

.wallets-modal__title {
  font-family: 'Panton', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
}

.wallets-modal__close {
  border: none;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: #999;
  padding: 4px 6px;
  
  &:hover {
    color: #666;
  }
}

.wallets-modal__body {
  padding: 8px 20px 16px;
  overflow-y: auto;
}

.wallets-modal__row {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  
  &:last-child {
    border-bottom: none;
  }
}

.wallets-modal__name {
  font-family: 'Panton', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 6px;
}

.wallets-modal__field {
  display: flex;
  gap: 6px;
  font-family: 'Panton', sans-serif;
  font-size: 12px;
  margin-bottom: 3px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.wallets-modal__label {
  min-width: 70px;
  color: #59779a;
  font-weight: 500;
}

.wallets-modal__value {
  color: #1a1a1a;
  font-weight: 500;
  word-break: break-all;
}

.copy-btn-small {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  padding: 0;
  background: #6a4bff;
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: #5a3bef;
  }
  
  svg {
    display: block;
  }
  
  .copied-text {
    font-size: 18px;
    font-weight: 500;
  }
}

.erase-btn {
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 10;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #ff4444;
  background: #ff4444;
  color: #fff;
  font-family: 'Panton', sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
  
  &:hover {
    background: #e63a3a;
    border-color: #e63a3a;
  }
}

.wallets-modal__title-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}

.erase-modal__text {
  font-family: 'Panton', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 14px;
}

.erase-modal__actions {
  display: flex;
  gap: 10px;
}

.erase-modal__agree {
  flex: 1;
  padding: 10px 12px;
  border-radius: 8px;
  border: none;
  background: #ff4444;
  color: #fff;
  font-family: 'Panton', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  
  &:hover {
    background: #e63a3a;
  }
}

.erase-modal__cancel {
  flex: 1;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #dde2ee;
  background: #f0f2f7;
  color: #1a1a1a;
  font-family: 'Panton', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  
  &:hover {
    background: #e8ebf0;
  }
}

@media (max-width: 768px) {
  .app {
    padding: 16px;
  }
  
  .logo {
    top: 16px;
    left: 16px;
    
    svg {
      height: 20px;
    }
  }
  
  .erase-btn {
    top: 16px;
    right: 16px;
    padding: 8px 10px;
    border-radius: 8px;
    font-size: 11px;
  }
  
  .container {
    padding-top: 50px;
  }
  
  .card {
    padding: 24px;
    border-radius: 16px;
  }
  
  .title {
    font-size: 24px;
  }
  
  .warning {
    font-size: 14px;
  }
}
</style>